import { StyleRules } from '@mui/styles'

const stylesheet: StyleRules = {
  root: {
    minWidth: 275,
    margin: '50px 50px'
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 5,
  },
  linkStyle: {
    textDecoration: 'none'
  },
  pageHeader: {
    margin: '20px 20px'
  },
  iconsStyle: {
    paddingTop: '0px',
    border: 0,
    float: 'left',
    marginRight: '15px',
    fill: 'var(--color-text-secondary)'
  },
  headerMenu: {
    width: '200px',
    fontFamily: 'Helvetica',
    fontSize: '19px',
    color: 'var(--color-text-primary)',
    textDecoration: 'none solid rgb(120, 120, 120)',
    lineHeight: '23px',
    marginBottom: '10px'
  },
  btnContainer: {
    padding: '0.5rem 1.375rem 1rem 0 !important',
    backgroundColor: 'var(--color-body-background)'
  },
  fullWidth: {
    width: '100%'
  },
  questionnaireContainer: {
    backgroundColor: "var(--color-body-background) !important",
    padding: "0rem 0rem 0.3rem 0rem!important",
    marginBottom: '0px !important',
    minHeight: '3rem !important',
  },
  zeroBottomMargin: {
    marginBottom: '0px'
  },
  questionnaireCardContainer: {
    padding: '0rem 0.8rem 0rem 0.8rem !important',
    //maxHeight: '28rem',
  },
  infoIcon: {
    color: 'var(--color-text-secondary) !important',
    paddingLeft: '0.1rem !important',
  },
  infoIconFont: {
    fontSize: '14px !important'
  },
  patientAccrodionBg: {
    backgroundColor: 'var(--color-background-subtle) !important'
  },
  boxBorder: {
    background: '#9e9b9b3d',
    boxShadow: '-3px 5px 5px -3px #a7a1a2,0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
    backgroundSize: '100% 5px !important',
    minHeight: '0.18rem'
  },
  searchBtn: {
    padding: '0rem 0.35rem !important',
    width: '2rem !important',
    left: '0.4rem !important',
    color: '#FFF !important',
    backgroundColor: 'var(--color-primary-dark) !important',
    borderColor: 'var(--color-primary-dark) !important',
    height: '1.7rem !important'
  },
  desc: {
    fontSize: '0.7rem !important'
  }
};

export default stylesheet;